import React from 'react';
import styled from 'styled-components';

import srcHasPhoto from '../assets/has-photo.svg';

import Dialog from '../../../../../../reusables/Dialog';
import DialogExtraImage from '../../../../../../reusables/Dialog/extras/image';
import DialogExtraCaption from '../../../../../../reusables/Dialog/extras/caption';

const CustomMessage = styled.div`
  margin-top: 16px;
  padding: 0 30px;
  text-align: center;

  > a {
    color: #5b36f2;
    text-decoration: underline;
    cursor: pointer;
  }
`;

interface IProps {
  handlerClose: () => void;
  show: boolean;
  handlerClick: () => void;
}

const YouNotHaveCycle = ({ handlerClose, show, handlerClick }: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    zIndex={1000}
  >
    <DialogExtraImage src={srcHasPhoto} alt="has-photo" />
    <DialogExtraCaption title="¿Aún no tienes foto?" />
    <CustomMessage style={{ marginBottom: 32 }}>
      Registra tu foto accediendo al trámite{' '}
      <a onClick={handlerClick} aria-hidden="true">
        Actualización de fotografía
      </a>
    </CustomMessage>
  </Dialog>
);

export default YouNotHaveCycle;
